<div class="reset-password-request">
  <h6>{{ 'module.public.resetPasswordRequest.headerText' | translate }}</h6>

  <form [formGroup]="resetRequestForm" class="form" *ngIf="!showConfirmation">
    <div class="form-field">
      <input
        formControlName="email"
        class="email"
        placeholder="{{ 'module.public.resetPasswordRequest.emailPlaceholderText' | translate }}"
        matInput
        type="email"
        autocomplete="off"
      />
    </div>
    <div class="errors-container">
      <mat-error *ngIf="this.resetRequestForm.controls.email.hasError('required')">
        {{ 'module.public.resetPasswordRequest.validationEmailRequiredText' | translate }}
      </mat-error>
      <mat-error *ngIf="this.resetRequestForm.controls.email.hasError('email')">
        {{ 'module.public.resetPasswordRequest.validationEmailValidText' | translate }}
      </mat-error>
    </div>
    <div class="buttons-container">
      <button class="buttons" (click)="cancel()">
        {{ 'module.public.resetPasswordRequest.cancelButtonText' | translate }}
      </button>
      <button class="buttons" [class.-disabled]="resetRequestForm.invalid" (click)="resetPassword()" [disabled]="resetRequestForm.invalid">
        {{ 'module.public.resetPasswordRequest.submitButtonText' | translate }}
      </button>
    </div>
  </form>

  <div
    class="reset-confirmation-message"
    *ngIf="showConfirmation"
    [innerHTML]="'module.public.resetPasswordRequest.confirmationInstructionMessage' | translate"
  ></div>
</div>
